/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lefoedauer2Inputs */

const de__field_lefoedauer2 = /** @type {(inputs: _Field_Lefoedauer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lerförderungsdauer in Minuten`)
};

/**

* @param {_Field_Lefoedauer2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lefoedauer2 = /** @type {((inputs?: _Field_Lefoedauer2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lefoedauer2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lefoedauer2(inputs)
});
export { _field_lefoedauer2 as "_field_leFoeDauer" }